/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {AdminResourceItemRoutePageComponent} from '../common/controller/admin-resource-item-route-page.component';
import {AdminResourceContextRoutePageComponent} from '../common/controller/admin-resource-context-route-page.component';
import {getRoutePageComponent} from '../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {adminResourceItemRouteResolve} from '../common/controller/admin-resource-routing';
import {PERMISSIONS} from '../../components/auth/auth-constants';
import {ReportScheduleCopyModalComponent} from './report-schedule-copy-modal.component';
import {ReportScheduleResource} from '../../components/api/resources/resource/report-schedule.resource';



export function reportScheduleStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper('report-schedules.report-schedule', ReportScheduleResource, 'app.rep', 'app');

        const readOnlyResolve = /*@ngInject*/ function() {
          const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

          return !LocalUserPermissions.hasNetwork(PERMISSIONS.manageReportTemplates.apiKey)
            && !LocalUserPermissions.hasAny(PERMISSIONS.runReports.apiKey);
        };
    
        $stateProvider.state(rh.listPath(), rh.list({
          views: {
            'content@app': { component: getRoutePageComponent('report-schedule-route') }
          },
          resolve: {
            readOnly: readOnlyResolve
          }
        }));
    
        $stateProvider.state(rh.newItemPath(), rh.newItem());
    
        $stateProvider.state(rh.itemPath(), rh.modelCommsItem({
          resolve: Object.assign({}, adminResourceItemRouteResolve('report-schedule-edit', 'edit'), {
            readOnly: readOnlyResolve,
            copyConfig: function() {
              return {
                modalComponent: ReportScheduleCopyModalComponent,
                stateUrl: 'app.rep.report-schedules.report-schedule',
                lcase: 'reportSchedule',
                ucase: 'ReportSchedule'
              };
            }
          }),
          views: {
            'content@app': { component: AdminResourceItemRoutePageComponent, bindings: { item: 'adminResourceItemKey', variant: 'adminResourceItemVariant' }  },
            'context@app': {component: AdminResourceContextRoutePageComponent}
          }
        }, 'ReportSchedule'));
  }, adnRouterHelper);
}
